import { setRefreshToken, userlogout } from "../components/slice/authService";
import { notifyAuthTokenRefreshed } from "../lib/axios";
import {
  clearSessionTokens,
  getAccessToken,
  getRefreshToken,
  hasSessionTokens,
  setSessionTokens,
} from "./authStorage";
import { broadcastSessionCleared, broadcastSessionPayload } from "./authSessionSync";
import {
  clearTokenRefreshAnchor,
  recordTokenRefreshAnchor,
} from "./tokenRefreshSchedule";

/**
 * Persist tokens to sessionStorage, sync Redux refresh, notify listeners, optional cross-tab broadcast.
 * Pass isLogin: true only for real login so the shared 10‑minute refresh clock starts from login.
 */
export function applySessionAuth(
  dispatch,
  { accessToken, refreshToken },
  { broadcast = true, tabId = null, isLogin = false } = {}
) {
  setSessionTokens({
    accessToken: accessToken ?? getAccessToken(),
    refreshToken: refreshToken ?? getRefreshToken(),
  });

  const storedRefresh = getRefreshToken();
  if (storedRefresh) {
    dispatch(setRefreshToken(storedRefresh));
  }

  notifyAuthTokenRefreshed();

  if (isLogin) {
    recordTokenRefreshAnchor();
  }

  if (broadcast) {
    broadcastSessionPayload(tabId, {
      accessToken: getAccessToken(),
      refreshToken: getRefreshToken(),
    });
  }
}

export function hasValidSession() {
  return hasSessionTokens();
}

/**
 * Clear session credentials and Redux auth state; optionally notify other tabs.
 */
export function endSession(
  dispatch,
  { broadcast = true, tabId = null, clearPersistedAppStorage = false } = {}
) {
  clearSessionTokens();
  clearTokenRefreshAnchor();
  dispatch(userlogout());

  if (broadcast) {
    broadcastSessionCleared(tabId);
  }

  if (clearPersistedAppStorage) {
    localStorage.clear();
  }
}
